import { translations } from "../../translations"
import styles from "./AboutMeWindow.module.css"

export default function InterestsSection() {
    return (
        <section className={styles.section}>
            <div className={styles.sectionTitleRow}>
                <img src="/images/icons/clover.svg" className={styles.sectionIconImg} alt="" />
                <h2 className={styles.sectionTitle}>{translations('about_me.other_interests')}</h2>
            </div>
            <ul className={styles.list}>
                <li>{translations('about_me.interest_design')}</li>
                <li>{translations('about_me.interest_games')}</li>
                <li>{translations('about_me.interest_books')}</li>
                <li>{translations('about_me.interest_photograph')}</li>
            </ul>
        </section>
    )
}
